import {Month, monthToUserString, Year} from "../lib/date-utils"
import {cardTypeToUserString} from "../lib/credit-card"
import * as React from "react"

export type StoredPayerDetails = MockPayerDetails | DeferredFailurePayerDetails | CreditCardDetails | DirectEntryDetails
export type MockPayerDetails = {type: 'mock', succeeds: boolean}
export type DeferredFailurePayerDetails = {type: 'missing'}
export type CreditCardDetails = {
	type: 'credit card'
	expiryMonth: Month
	expiryYear: Year
	pan: string
	cardType: CreditCardType
}
export type DirectEntryDetails = {
	type: 'direct entry'
	bsb: string,
	accountNumber: string
}

const PayerCreditCard = (details: CreditCardDetails) =>
	<ul className={`creditcard ${details.cardType}`}>
		<li>{cardTypeToUserString(details.cardType)}</li>
		<li>{details.pan}</li>
		<li>Expires {monthToUserString(details.expiryMonth)} {details.expiryYear}</li>
	</ul>

const PayerDirectEntry = (details: DirectEntryDetails) =>
	<ul>
		<li>{details.bsb}</li>
		<li>{details.accountNumber}</li>
	</ul>

const PayerSelector = (params: {details: StoredPayerDetails}) => {
	const details = params.details
	switch (details.type) {
		case 'credit card': return <PayerCreditCard {...details as CreditCardDetails}/>
		case 'direct entry': return <PayerDirectEntry {...details as DirectEntryDetails}/>
		default: return <span>If you are reading us, please contact us because there is a problem</span>
		//i haven't written a renderer for the Mock payer, because it should only exist in test cases.
		//i haven't written a renderer for the FailurePayer, because it should represent only a system configuration error
	}
}

export const Payer = (params: {details: StoredPayerDetails}) =>
	<div className="IvtAoOrders2PaymentDetailsWidget"><PayerSelector {...params} /></div>




// WEBPACK FOOTER //
// ./src/orders2/payment-details-widget.tsx